<template>
        <div class="row justify-content-center">
            <div class="col-lg-5 col-md-7">
                <div v-if="!isLoading" class="card bg-secondary shadow border-0">
                    <div v-if="valid && status.type === ''" class="card-body px-lg-5 py-lg-5">
                        <form  @submit.prevent="create">
                            <h6 class="heading-small text-muted mb-4 text-center">Bitte laden Sie Ihren Nachweis hoch</h6>
                            <div class="row">
                                <div class="col-xl-2 text-center">
                                    <span class="text-muted text-sm ">Der QR Code ist nur einmal gültig und hat eine Gültigkeitsdauer von maximal 15 Minuten.</span><br>
                                    <span class="text-muted text-underline  text-sm mt-3 mb-5">Läuft ab {{tokenexpiresAt|formatDateFromNow}}.</span><hr>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <label class="form-control-label mt-3">
                                                    Dokument
                                                    <span>*</span></label>
                                                <input :disabled="isLoading2" class="form-control form-control-alternative" v-bind:class="{'bg-danger':(document.size > 2097152)}"
                                                       type="file" id="document" ref="documentfile" v-on:change="handleFileUpload()"
                                                       accept="image/png,image/jpeg,application/pdf,application/x-pdf"
                                                />
                                                <badge v-if="document.size > 2097152" type="danger" class="mx-auto my-3" >Die Datei ist zu groß! Maximal 2MB!</badge>
                                </div>
                            </div>
                            <div v-if="isTextScanned && !isTextScanning" class="row mt-4">
                                <div class="col-xl-6">
                                    <base-input
                                                        label="Ausgestellt am:"
                                                        :disabled="isLoading2"
                                                        required
                                                        class="col-form-label col-form-label-lg"
                                                    >
                                                        <flat-pickr slot-scope="{focus, blur}"
                                                                    @on-open="focus"
                                                                    @on-close="blur"
                                                                    ref="pickr"
                                                                    :config="config"
                                                                    :class="['form-control','form-control-alternative','form-control-lg','datepicker']"
                                                                    v-model="profileDocument.issuedAt">
                                                        </flat-pickr>
                                                    </base-input>
                                </div>
                                <div class="col-xl-6">
                                                <base-input
                                                    label="Läuft ab am:"
                                                    :disabled="isLoading2"
                                                    required
                                                    class="col-form-label col-form-label-lg"
                                                >
                                                    <flat-pickr slot-scope="{focus, blur}"
                                                                @on-open="focus"
                                                                @on-close="blur"
                                                                ref="pickr"
                                                                :config="config"
                                                                :class="['form-control','form-control-alternative','form-control-lg','datepicker']"
                                                                v-model="profileDocument.invalidAt">
                                                    </flat-pickr>
                                                </base-input>
                                </div>
                            </div>
                            <div v-if="isTextScanned && !isTextScanning" class="row">
                                            <div class="col-xl-2">
                                                <label class="form-control-label">
                                                    Erstschulung?
                                                </label>
                                                <switches v-model="profileDocument.isFirst"
                                                          :disabled="isLoading2"
                                                          theme="bootstrap"
                                                          color="primary"
                                                          style="padding-left: 2rem;"
                                                          text-enabled="Ja, Erstschulung"
                                                          text-disabled="Nein, Wiederholungsschulung"></switches>
                                            </div>
                                            <div class="col-xl-2">
                                                <label class="form-control-label">
                                                Typ
                                                    <span>*</span></label>
                                                <select v-model="profileDocument.type"
                                                    :disabled="isLoading2"
                                                    class="mb-3 custom-select form-control form-control-alternative form-control-lg">
                                                    <option v-for="d in docOptions" :key="d" :value="d">{{ d }}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div v-if="isTextScanned && !isTextScanning" class="row">
                                            <div class="col-xl-8">
                                                <label class="form-control-label">
                                                    Bezeichnung
                                                </label>

                                                <vue-simple-suggest
                                                    v-model="profileDocument.name"
                                                    :disabled="isLoading2"
                                                    :list="items"
                                                    :styles="autoCompleteStyle"
                                                    display-attribute="name"
                                                    :filter-by-query="true">
                                                    <!-- Filter by input text to only show the matching results -->
                                                </vue-simple-suggest>
                                            </div>
                                     </div>
                            <div v-if="isTextScanning" class="row text-center mt-4">
                                <div class="col-xl-8">
                                    <h2 class="text-muted">Lese Dokument ...</h2>
                                    <font-awesome-icon icon="circle-notch" size="6x" class="p-3 mx-auto text-muted" spin/>
                                </div>
                            </div>
                            <!----
                                <div class="row">
                                    <div class="col">
                                        <base-input alternative=""
                                                    required
                                                    label="Beschreibung"
                                                    input-classes="form-control-alternative form-control-lg"
                                                    v-model="profileDocument.description"
                                        />
                                    </div>
                                </div> --->
                            <button :key="'btn'+key" class="btn btn-icon my-4 btn-primary" :disabled="isLoading2">
                                <span class="btn-inner--icon"><i v-if="isLoading2" class="fas fa-circle-notch fa-spin"></i><i v-else class="ni ni-fat-add"></i></span>
                                <span class="btn-inner--text">Nachweis anlegen</span></button>
                        </form>
                    </div>
                    <div v-else-if="valid && status.type === 'success'" class="card-body px-lg-5 py-lg-5 text-center p-3">
                        <h2>Erfolgreich hinzugefügt!</h2>
                        <font-awesome-icon icon="check" size="6x" class="p-3 mx-auto text-success"/>
                        <h3>Sie haben den Nachweis erfolgreich hinzugefügt! Sie können Ihre Eingaben jetzt am PC überprüfen.</h3>
                    </div>
                    <div v-else class="card-body px-lg-5 py-lg-5 text-center p-3">
                        <h2>Abgelaufen!</h2>
                        <font-awesome-icon icon="ban" size="6x" class="p-3 mx-auto text-danger"/>
                        <h3>Dieser Link ist nicht mehr gültig!</h3>
                    </div>

                </div>
                <div v-else class="card bg-secondary shadow border-0 text-center p-3">
                    <h2>Validiere Anfrage ...</h2>
                    <font-awesome-icon icon="circle-notch" size="6x" class="p-3 mx-auto" spin/>
                    <h3>Dies kann einen Moment dauern!</h3>
                </div>
                <div class="row mt-3">
                    <div class="col-6 text-right">
                      <!---  <a href="https://socialguard.app" class="text-light" target="_blank"><small>Create new account</small></a> ---->
                    </div>
                </div>
            </div>

        </div>
</template>
<script>
    import axios from 'axios';
    import flatPickr from "vue-flatpickr-component";
    import "flatpickr/dist/flatpickr.css";
    import { German } from "flatpickr/dist/l10n/de.js";
    import Switches from "vue-switches";
    import RecognizeDocumentText from "@/Mixins/RecognizeDocumentText";
  export default {
    name: 'ProfileDocumentUpload',
      components:{flatPickr, Switches},
      mixins: [RecognizeDocumentText],
      data() {
      return {
          status: {type: '' },
          isTextScanning: false,
          isTextScanned: false,
          model: {
              token: '',
              plainPassword: ''
          },
          profileDocument: {
              token: '',
              isFirst: false,
              document: null,
              type: '',
              name: '',
              description: '',
              invalidAt: null,
              issuedAt: null,
          },
          document: '',
          submitted: false,
          isLoading: true,
          isLoading2: false,
          key: 1,
          valid: false,
          logintoken: null,
          tokenexpiresAt: null,
          config: {
              dateFormat: 'Y-m-d',
              altFormat: 'd.m.Y',
              altInput: true,
              allowInput: true,
              locale: German
          },
          items: [
              { id: 1, name: 'Präventionsschulung Servicekraft'},
              { id: 2, name: 'Schulung Verwaltung'},
              { id: 3, name: 'Schulung Sozialkonzeptbeauftragte'},
              { id: 4, name: 'Besondere Schulung (GlüStV $ 29 Abs. 4)'},
              { id: 5, name: 'IHK Schulung'},
              { id: 6, name: 'Dienstanweisung JuSchG'},
              { id: 7, name: 'Dienstanweisung Sozialkonzept Servicekraft'},
              { id: 8, name: 'Dienstanweisung Sozialkonzept Verwaltung'},
              { id: 9, name: 'Dienstanweisung Verpflichtungserklärung'},
              { id: 10, name: 'Modul A'},
              { id: 11, name: 'Modul B'},
              { id: 12, name: 'Sonstige'},
          ],
          docOptions: ['Zertifikat','Schulung','Unterweisung', 'Sonstiges'],
          autoCompleteStyle : {
              vueSimpleSuggest: "position-relative",
              inputWrapper: "input-wrapper",
              defaultInput : "form-control form-control-alternative form-control-lg",
              suggestions: "position-absolute list-group z-100-overflow",
              suggestItem: "list-group-item"
          }
        }
    },
      computed: {
          alert () {
              return this.$store.state.alert
          },
          validPasswordReset() {
              return this.validPassword(this.model.plainPassword) && this.model.plainPassword === this.plainPassword2;
          }
      },
      created () {
        this.profileDocument.token = this.$route.params.token;
        this.isValid(this.profileDocument.token).then(response => {
            this.valid = response.status;
            this.logintoken = response.logintoken;
            this.tokenexpiresAt = response.expiresAt;
            this.isLoading = false
        })
      },
      methods: {
        isValid(token) {
            return new Promise((resolve, reject) => {
                const requestOptions = {
                    method: 'GET',
                    // headers: { 'Content-Type': 'application/json' },
                };

                fetch(process.env.VUE_APP_API_SERVER + `/pd/validtoken/` + token, requestOptions)
                    .then(this.handleResponse)
                    .then(response => {
                        resolve(response);
                    },
                        error => {
                            reject(error);

                        });
            });
        },
          create() {
              this.$store.dispatch('alert/clear');
              this.isLoading2 = true;
              this.key++;
              this.submitDocument().then(() => {
                  if (this.profileDocument.document === '') {
                      this.$store.dispatch('alert/error', 'Bitte Document hochladen');
                      this.isLoading2 = false;
                      this.key++;
                  } else if (this.profileDocument.type === ''  || this.profileDocument.name === '' || this.profileDocument.issuedAt === null) {
                          this.$store.dispatch('alert/error','Bitte füllen Sie alle Felder aus!');
                      this.isLoading2 = false;
                      this.key++;
                  } else {
                      this.handleSubmit()
                          .then(response => {
                              this.isLoading2 = false;
                              this.status =  {type: 'success', msg: 'Nachweis (ID: '+response.id+') wurde erstellt. '};
                              this.$store.dispatch('alert/success',this.status.msg);
                              this.key++;
                          })
                          .catch(error => {
                              this.isLoading2 = false;
                              this.status =  {type: 'danger', msg: error};
                              this.key++;
                          })
                  }
              });
          },
          handleFileUpload() {
              this.document = this.$refs.documentfile.files[0];
              this.isTextScanning = true;
              this.profileDocument.issuedAt = null;
              this.profileDocument.expiresAt = null;
              this.profileDocument.name = null;
              this.profileDocument.type = null;
              this.profileDocument.description = null;
              if (this.document.type === 'application/pdf') {
                this.convertBlobToImage(this.document).then(img => {
                  this.recognizeDocument(img.data).then(resp => {
                    this.fillForm(resp)
                    this.stopLoading()
                  }).catch(err => {
                    this.$store.dispatch('alert/error','Da ist etwas schief gelaufen. FEHLER: '+err)
                    this.stopLoading()
                  })
                }).catch(err => {
                  this.$store.dispatch('alert/error','Da ist etwas schief gelaufen. FEHLER: '+err)
                  this.stopLoading()
                })
              } else {
                  // tesseract ocr => check for document type and prefill form
                  this.recognizeDocument(this.document).then(resp => {
                      this.fillForm(resp)
                      this.stopLoading()
                  }).catch(err => {
                    this.$store.dispatch('alert/error','Da ist etwas schief gelaufen. FEHLER: '+err)
                    this.stopLoading()
                  })
              }
          },
        fillForm(resp) {
          this.profileDocument.issuedAt = resp.issuedAt;
          this.profileDocument.expiresAt = resp.expiresAt;
          this.profileDocument.name = resp.name;
          this.profileDocument.type = resp.type;
          this.profileDocument.description = resp.description;
        },
          submitDocument() {
              return new Promise((resolve, reject) => {
                  const header = this.authHeader();
                  header['Authorization'] = 'Bearer ' + this.logintoken ;
                  header['Content-Type'] = 'application/json';
                  let formData = new FormData();
                  formData.append('file', this.document);
                  axios.post(process.env.VUE_APP_API_SERVER +'/api/documents',
                      formData,
                      {
                          headers:header
                      }
                  ).then(response => {
                      this.profileDocument.document = response.data['@id'];
                      resolve(response)
                      //this.$store.dispatch('alert/success','Privates Zertifikat erfolgreich hochgeladen');
                  })
                      .catch(error => {
                          this.$store.dispatch('alert/error', error);
                          reject(error)
                      });

              })
          },
          handleSubmit () {
              return new Promise((resolve, reject) => {
                  this.submitted = true;
                  let senddata = this.profileDocument;

                  const requestOptions = {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify(senddata)
                  };
                  fetch(process.env.VUE_APP_API_SERVER + `/pd/upload`, requestOptions)
                      .then(this.handleResponse)
                      .then(response => {
                          resolve(response)
                      },
                          error => {
                            reject(error);
                      });
              });

          },
        stopLoading() {
          this.isTextScanned = true;
          this.isTextScanning = false;
          this.tick++
        }
      }
  }
</script>
<style>
</style>
